<template>
  <div class="item-container">
    <div
      class="item-main">
      <div class="item-title">
        <i class="material-icons vtd-icon-4 vtd-mr-3 vtd-align-middle"><span></span></i>
        <span>{{ item.title.toUpperCase() }}</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      dropdown: true,
    }
  },
  mounted() {
    this.$root.$on("collapseall", () => {
      this.collapseAll();
    });
    this.$root.$on("expandall", () => {
      this.expandAll();
    });
  },
  methods: {
    expandAll () {
      this.dropdown = true
    },
    collapseAll () {
      this.dropdown = false
    }
  }
};
</script>

<style lang="scss">
  @import './styles.scss';

</style>
